import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setCollege } from "../../../../../store/slices/master/collegeSlice";
import { cloneDeep, baseURL } from "../../../../../constants/commonConstants";
import {
  IViewCollege,
  ICollegeData,
} from "../../../../../models/master/college";

const ViewCollege = (props: IViewCollege) => {
  const dispatch = useDispatch();
  const { setShowView, college } = props;

  // states

  const [data, setData] = useState<ICollegeData>(cloneDeep(college));

  useEffect(() => {
    if (college) {
      let _college = cloneDeep(college);
      setData(_college);
    }
  }, [college]);

  useEffect(() => {
    return () => {
      dispatch(setCollege(undefined));
    };
  }, []);

  console.log(college);

  return (
    <>
      {data && (
        <>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
              University Management Details
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowView(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="label-group-wrap mt-3">
              <div className="row">
                <div className="col-lg-12 label-group">
                  <p>
                    <img
                      src={data.collegeLogo ? baseURL + data.collegeLogo : ""}
                      alt=""
                      className="w-25"
                    />
                  </p>
                </div>
                <div className="col-lg-6 label-group">
                  <label>University Management Type</label>
                  <p>{data.collegeTypeName}</p>
                </div>
                <div className="col-lg-6 label-group">
                  <label>University Management Name</label>
                  <p>{data.collegeName}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label>Address</label>
                  <p>{data.address}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label>Location</label>
                  <p>{data.location}</p>
                </div>

                <div className="col-lg-12 label-group">
                  <label>Description</label>
                  <p>{data.description}</p>
                </div>

                <div className="col-lg-12 label-group">
                  <label>Login User Name</label>
                  <p>{data.collegeLoginUserName} </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowView(false)}
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewCollege;
